import RelatedItems from "components/related-items";
import React from "react";

import { SanityRelatedItems } from "../types";

const RelatedItemsRenderer = ({ value }: { value: SanityRelatedItems }) => <RelatedItems {...value} />;

export default RelatedItemsRenderer;
